import styled from 'styled-components';

interface LoadingProps {
	$loading: boolean;
}

export const Loading = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	/* background: var(--ion-color-primary); */
	animation: fade 1s alternate infinite ease-in-out;
	z-index: 1;
	transition: opacity 0.3s;
	opacity: ${(props: LoadingProps) => (props.$loading ? 1 : 0)};
	pointer-events: none;
`;

export const VideoContainer = styled.div`
	width: 100%;
	/* height: 100%; */
	/* position: absolute; */
	position: relative;
	isolation: isolate;
	border-radius: 5px;
	overflow: hidden;
`;

export const TestVideo = styled.video`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	/* position: absolute; */
	border-radius: 5px;
	inset: 0;
	opacity: ${(props: LoadingProps) => (props.$loading ? 0 : 1)};
`;
